import { combineReducers } from 'redux';
import categoriaReducer from './reducers/categoriaReducer.js';
import juegoReducer from './reducers/juegoReducer.js';
import loginReducer from './reducers/loginReducer.js';
import paisReducer from './reducers/paisReducer.js';
import reventasReducer from './reducers/reventasReducer.js'
import solicitudReducer from './reducers/solicitudReducer.js';
import usuarioReducer from './reducers/usuarioReducer.js';
import shoppingCartReducer from './reducers/shoppingCartReducer.js'
import solicitudComprasReducer from './reducers/solicitudComprasReducer.js'
import cuentaReducer from './reducers/cuentaReducer.js'


const rootReducer = combineReducers({
  categoria: categoriaReducer,
  juego:juegoReducer,
  login:loginReducer,
  pais:paisReducer,
  reventa:reventasReducer,
  solicitud:solicitudReducer,
  usuario:usuarioReducer,
  shoppingCart:shoppingCartReducer,
  solicitudCompras:solicitudComprasReducer,
  cuentas:cuentaReducer
});

export default rootReducer;